module.exports = __webpack_public_path__ + "static/media/pencil.cf7652d9.svg";